window.storeTheme = window.storeTheme || ({} as StoreTheme);

function internalRegisterSession() {
  return fetch('/api/sessions/', {
    method: 'POST',
    headers: {
      accept: '*/*',
      'accept-language': 'pt-BR,pt;q=0.9,en-US;q=0.8,en;q=0.7',
      'content-type': 'application/json',
      'cache-control': 'no-cache',
      pragma: 'no-cache',
    },
    referrer: window.location.href,
    referrerPolicy: 'no-referrer-when-downgrade',
    mode: 'cors',
    credentials: 'include',
    body: '{"public":{}}',
  });
}

/**
 * Realiza logout do usuário atualmente autenticado
 */

export async function logout() {
  const $document = $(document);
  await fetch(
    `/api/vtexid/pub/logout?scope=${window?.vtxctx?.transurl}&returnUrl=${window?.vtxctx?.transurl}
  `,
    {
      headers: {
        accept:
          'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.9',
        'accept-language': 'pt-BR,pt;q=0.9,en-US;q=0.8,en;q=0.7',
        'cache-control': 'no-cache',
        pragma: 'no-cache',
        'sec-fetch-dest': 'document',
        'sec-fetch-mode': 'navigate',
        'sec-fetch-site': 'same-origin',
        'sec-fetch-user': '?1',
        'upgrade-insecure-requests': '1',
      },
      referrer: window.location.href,
      referrerPolicy: 'no-referrer-when-downgrade',
      body: null,
      method: 'GET',
      mode: 'cors',
      credentials: 'include',
      redirect: 'manual',
    },
  ).then(() => {
    // HTTP 30x response
    return false;
  });

  //seta novo id para quando o usuario desloga

  function uuidv4() {
    return `${[1e7]}-${1e3}-${4e3}-${8e3}-${1e11}`.replace(/[018]/g, (c) =>
      // @ts-ignore
      (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16),
    );
  }

  await fetch('/api/checkout/pub/orderForm/' + uuidv4().replace(/\-/, '') + '?refreshOutdatedData=true', {
    headers: {
      accept: 'application/json, text/javascript, */*; q=0.01',
      'cache-control': 'no-cache',
      'content-type': 'application/json; charset=UTF-8',
    },
    referrer: window.location.href,
    body: '{}',
    method: 'POST',
    mode: 'cors',
    credentials: 'include',
  });

  await internalRegisterSession();
  $document.trigger('userAuthChanged', { authenticated: false });
  $document.trigger('userAuthLogout');
  setTimeout(() => {
    window.location.reload();
  }, 100);
}

Object.assign(window.storeTheme, {
  user: Object.assign(window.storeTheme.user || {}, {
    isAuthenticated: null,
    data: {},
  }),
});

(() => {
  const $document = $(document);
  const $body = $document.find('.rnk-body-myaccount');

  //listener para botão sair header
  $document.on('click', '.logout', (event) => {
    event.preventDefault();
    window.storeTheme?.helpers?.loader?.topbar?.show();
    logout();
  });

  //listener para botão sair da vtex - my account
  document.querySelector('#inicio-conteudo').addEventListener('click', (event) => {
    // @ts-ignore
    if (event.target.classList.contains('vtex-account_menu-link') && event.target.innerText.indexOf('Sair') > -1) {
      event.stopPropagation();
      window.storeTheme?.helpers?.loader?.topbar?.show();
      setTimeout(() => {
        logout();
      }, 500);
    }
  });
  $document.on('click', '.open-modal-login', (event) => {
    event.preventDefault();
    window.storeTheme?.helpers?.loader?.topbar?.show();
    window.location.href = `/login?ReturnUrl=${encodeURIComponent(
      `${window.location.pathname}${window.location.search}${window.location.hash}`,
    )}`;
    // window?.vtexid?.start();
  });

  $.ajaxSetup({
    dataFilter: function (data, type) {
      try {
        if (data && type === 'json' && data.indexOf('isAuthenticated') > -1 && data.indexOf('namespaces') > -1) {
          // utilizar conteúdo previamente e sempre chamado pela Vtex para acesso ao conteúdo sem necessitar chamar mais uma vez a validação se usuário está autenticado
          const jsonData = JSON.parse(data);
          if (jsonData?.namespaces?.profile?.isAuthenticated?.value === 'true') {
            window.storeTheme.user.isAuthenticated = true;
            window.storeTheme.user.data = jsonData;
          } else {
            window.storeTheme.user.isAuthenticated = false;
          }
          $(window).trigger('user.storeTheme');
        }
      } catch (e) {
        console.error(e);
      }
      return data;
    },
  });
})();

export default {};
